"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeCustomerOrderHandler = removeCustomerOrderHandler;
var RemoveCustomerOrderFailed = _interopRequireWildcard(require("@ori-events/remove-customer-order-failed"));
var _types = require("../types");
var _utils = require("../utils");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
async function removeCustomerOrderHandler({
  detail: {
    endConsumerOrderId,
    placement
  }
}) {
  const fetchUrl = `${_types.RequestUrl.RemoveCustomerOrder}?endConsumerOrderId=${endConsumerOrderId}`;
  const response = await fetch(fetchUrl, (0, _utils.getHttpRequestSettings)({
    placement
  }));
  const data = (0, _utils.convertToCamelCase)(await response.json());
  if (RemoveCustomerOrderFailed.isRemoveCustomerOrderErrorResponse(data)) {
    const errorEvent = new CustomEvent(RemoveCustomerOrderFailed.Name, {
      detail: data
    });
    window.dispatchEvent(errorEvent);
    return false;
  }
  return data;
}